export default __webpack_public_path__ + "static/decoratorEditor-b44afa99812d79cc62b737e54a09d320.png";